const SESSION_KEY = 'yd_inversor_session';

export function setInversorSession(username) {
  sessionStorage.setItem(
    SESSION_KEY,
    JSON.stringify({ username, at: Date.now() })
  );
}

export function getInversorSession() {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearInversorSession() {
  sessionStorage.removeItem(SESSION_KEY);
}

export function isInversorAuthenticated() {
  return !!getInversorSession();
}
